import React, { useState, useRef } from "react";
import useTableScroll from "../../useTableScrollcesar";
import { Mensaje, MensajeSiNo } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import axios from "axios";
import moment from "moment";
import Modal from "react-bootstrap/Modal";
import {
  formatMoneda,
  seleccionarCampo,
  validaMonto,
  formatoMonto,
} from "../../../util/varios";
import CatalogoComercio from "../../../catalogos/catalogoComercio";
import CatalogoInmueble from "../../../catalogos/catalogoInmueble";
import {
  Input,
  Radio,
  SearchInput,
  Select,
  Textarea,
} from "../../../ui/inputs/Input";
import { DangerButton, SuccessButton } from "../../../ui/buttons/Button";

export const TasasPagos = (props) => {
  moment.locale("es-us");
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));
  const txtConcepto = useRef();
  const txtNombre = useRef();
  const txtRif = useRef();
  const txtDireccion = useRef();
  const txtTotal = useRef("0,00");
  const txtUnidad = useRef();
  const [titulo] = useState();
  const [msg] = useState();

  const [mostrarComercio, setMostrarComercio] = useState(false);
  const [mostrarInmueble, setMostrarInmueble] = useState(false);
  const [recargar, setRecargar] = useState(false);

  const cmbDepartamento = useRef();
  const cmbTipoIngreso = useRef();
  const cmbCantidad = useRef();
  const cmbRif = useRef();

  const radioGeneral = useRef();
  const radioComercio = useRef();
  const radioInmueble = useRef();

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [visibleUT, setVisibleUT] = useState("hidden");
  const [tipoIngreso, setTipoIngreso] = useState();
  const [habilitaBotBuscar, setHabilitaBotBuscar] = useState(false);
  const [idContribuyente, setIdcontribuyente] = useState();

  let token = localStorage.getItem("jwtToken");
  let op = require("../../../../src/modulos/datos");

  const headCells = [
    { label: "#", textAlign: "center" },
    { label: "Fecha", textAlign: "center" },
    { label: "Tipo", textAlign: "center" },
    { label: "Concepto", textAlign: "center" },
    { label: "Monto", textAlign: "center" },
  ];

  const {} = useTableScroll(headCells);

  const onChange = (e) => {
    if (
      e.target.id === "inputNombre" ||
      e.target.id === "inputDireccion" ||
      e.target.id === "inputRif"
    ) {
      e.target.value = e.target.value.toUpperCase();
    } else if (e.target.id === "radioGeneral") {
      cmbRif.current.value = "J";
      txtRif.current.value = "";
      txtNombre.current.value = "";
      txtDireccion.current.value = "";
      setHabilitaBotBuscar(false);
    } else if (
      e.target.id === "radioComercio" ||
      e.target.id === "radioInmueble"
    ) {
      cmbRif.current.value = "J";
      txtRif.current.value = "";
      txtNombre.current.value = "";
      txtDireccion.current.value = "";
      setHabilitaBotBuscar(true);
    }
  };

  const seleccionarTipoIngreso = () => {
    let tipodepart = "'" + cmbDepartamento.current.value.toString() + "'";
    let campos = "*";
    let nomtab = "tasasweb";
    let condi = "tipodepart = " + tipodepart;
    let orden = "idtasasweb";

    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setTipoIngreso(response.data);
            cmbTipoIngreso.current.value = response.data[0].idtipoingreso;
            if (parseInt(response.data[0].variable) === 0) {
              setVisibleUT("hidden");
            } else {
              setVisibleUT("visible");
            }
            cmbCantidad.current.value = 1;
            txtConcepto.current.value =
              "PAGO DE " +
              cmbTipoIngreso.current[cmbTipoIngreso.current.selectedIndex].text;
            calculaMonto(
              parseInt(
                response.data[cmbTipoIngreso.current.selectedIndex].variable
              ) === 0
                ? false
                : true,
              response.data
            );
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const procesarFactura = (body) => {
    let endpoint = `${op.conexion}/api/Caja_Ingreso/crearfactura`;
    setActivate(true);

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        setActivate(false);
        if (response.status == 200) {
          let msg = "Desea Facturar otros Impuestos al mismo Contribuyente?.";
          setMensajesino({
            mostrar: true,
            titulo: "Confirmación.",
            texto: msg,
            icono: "confirmacion",
          });
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    cmbTipoIngreso.current.selectedIndex = 0;
    cmbCantidad.current.selectedIndex = 0;
    setRecargar(true);
  };

  const blanquear = () => {
    setRecargar(false);
    setHabilitaBotBuscar(false);
  };

  const handleCatalogo = () => {
    if (radioComercio.current.checked === true) {
      setMostrarComercio(true);
    } else if (radioInmueble.current.checked === true) {
      setMostrarInmueble(true);
    }
  };

  const cancelar = (e) => {
    e.preventDefault();
    setTipoIngreso();
    if (recargar) {
      txtNombre.current.value = "";
      txtRif.current.value = "";
      txtDireccion.current.value = "";
      blanquear();
      props.onHideAcepta();
    } else {
      blanquear();
      props.onHideCancela();
    }
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;

    if (txtNombre.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir el Nombre del Contribuyente",
        icono: "informacion",
      });
      sigue = false;
      txtNombre.current.focus();
    } else if (txtRif.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir la Cédula o Rif del Contribuyente",
        icono: "informacion",
      });
      sigue = false;
      txtRif.current.focus();
    } else if (txtDireccion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir la Dirección del Contribuyente",
        icono: "informacion",
      });
      sigue = false;
      txtDireccion.current.focus();
    } else if (
      txtTotal.current.value.trim() === "" ||
      txtTotal.current.value.trim() === "0,00"
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Introduzca el Monto",
        icono: "informacion",
      });
      sigue = false;
      txtTotal.current.focus();
    } else if (sigue) {
      var factu = [];
      var factudet = [];

      factu.push({
        totalinmpuesto: txtTotal.current.value
          .replace(/\./g, "")
          .replace(",", "."),
        totalrecargo: 0.0,
        totalinteres: 0.0,
        idtipoingreso:
          tipoIngreso[cmbTipoIngreso.current.selectedIndex].idtipoingreso,
        fechaemision: fechaSistema,
        descripcion: txtConcepto.current.value,
        status: 0,
        nombrecontri: txtNombre.current.value,
        direccioncontri: txtDireccion.current.value,
        cedrif: cmbRif.current.value + txtRif.current.value,
        totalmulta: 0.0,
        deducible: 0.0,
        facturador: idusuario,
        idtasasweb:
          tipoIngreso[cmbTipoIngreso.current.selectedIndex].idtasasweb,
        tablacontribuyente:
          radioComercio.current.checked === true
            ? "comercio"
            : radioInmueble.current.checked === true
            ? "inmueble"
            : "",
      });

      factudet.push({
        montoimpuesto: txtTotal.current.value
          .replace(/\./g, "")
          .replace(",", "."),
        montorecargo: 0.0,
        montointeres: 0.0,
        periodo:
          fechaSistema.substring(6, 8) + "/" + fechaSistema.substring(0, 4),
      });
      let body = {
        idcontri:
          radioComercio.current.checked === true ||
          radioInmueble.current.checked === true
            ? idContribuyente
            : 0,
        factu: JSON.stringify(factu),
        factudet: JSON.stringify(factudet),
        nomtab: "",
        tipoimpu: "",
        idingremul: 0,
      };
      procesarFactura(body);
    }
  };

  const handleChangeDeparatamento = (event) => {
    cmbCantidad.current.value = 1;
    txtUnidad.current.value = "0,00";
    txtTotal.current.value = "0,00";
    txtConcepto.current.value = "";
    setVisibleUT("hidden");
    setTipoIngreso();
    seleccionarTipoIngreso();
  };

  const handleChangeTipoIngreso = (event) => {
    cmbCantidad.current.value = 1;
    txtUnidad.current.value = "0,00";
    if (
      parseInt(tipoIngreso[cmbTipoIngreso.current.selectedIndex].variable) === 0
    ) {
      setVisibleUT("hidden");
    } else {
      setVisibleUT("visible");
    }
    txtConcepto.current.value =
      "PAGO DE " +
      cmbCantidad.current.value +
      " " +
      cmbTipoIngreso.current[cmbTipoIngreso.current.selectedIndex].text;
    calculaMonto(
      parseInt(tipoIngreso[cmbTipoIngreso.current.selectedIndex].variable) === 0
        ? false
        : true,
      tipoIngreso
    );
  };

  const calculaMonto = (visibleUni, tipoIngre) => {
    let valTasa = tipoIngre[cmbTipoIngreso.current.selectedIndex].valor;
    let unid = 1.0;

    if (visibleUni && txtUnidad.current.value !== "0,00") {
      unid = txtUnidad.current.value.replace(/\./g, "").replace(",", ".");
    }
    let montoTasa =
      (parseFloat(valTasa) * parseFloat(props.factorCambio)).toFixed(2) *
      parseFloat(cmbCantidad.current.value) *
      parseFloat(unid);
    txtTotal.current.value = formatMoneda(
      montoTasa.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
  };

  const handleChangeCantidad = (event) => {
    if (
      cmbTipoIngreso.current[cmbTipoIngreso.current.selectedIndex].text !== ""
    ) {
      txtConcepto.current.value =
        "PAGO DE " +
        cmbCantidad.current.value +
        " " +
        cmbTipoIngreso.current[cmbTipoIngreso.current.selectedIndex].text;
      calculaMonto(
        parseInt(tipoIngreso[cmbTipoIngreso.current.selectedIndex].variable) ===
          0
          ? false
          : true,
        tipoIngreso
      );
    }
  };

  const handleInputChange1 = (event) => {
    txtTotal.current.value = "0,00";
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which === 13 || typeof event.which === "undefined") {
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
      calculaMonto(
        parseInt(tipoIngreso[cmbTipoIngreso.current.selectedIndex].variable) ===
          0
          ? false
          : true,
        tipoIngreso
      );
      if (event.which === 13) {
        txtConcepto.current.focus();
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const infoCatalogoC = (datos) => {
    setMostrarComercio(false);
    setIdcontribuyente(datos.idCome);
    txtNombre.current.value = datos.nombre;
    cmbRif.current.value =
      datos.rif.substring(0, 1) !== "J" &&
      datos.rif.substring(0, 1) !== "V" &&
      datos.rif.substring(0, 1) !== "G" &&
      datos.rif.substring(0, 1) !== "E" &&
      datos.rif.substring(0, 1) !== "P"
        ? ""
        : datos.rif.substring(0, 1);
    txtRif.current.value =
      datos.rif.substring(0, 1) !== "J" &&
      datos.rif.substring(0, 1) !== "V" &&
      datos.rif.substring(0, 1) !== "G" &&
      datos.rif.substring(0, 1) !== "E" &&
      datos.rif.substring(0, 1) !== "P"
        ? datos.rif
        : datos.rif.substring(1);
    txtDireccion.current.value = datos.direccion;
  };

  const infoCatalogoI = (idontri, nomcontri, codcat, cedcontri, dircontri) => {
    setMostrarInmueble(false);
    setIdcontribuyente(idontri);
    txtNombre.current.value = nomcontri;
    cmbRif.current.value =
      cedcontri.substring(0, 1) !== "J" &&
      cedcontri.substring(0, 1) !== "V" &&
      cedcontri.substring(0, 1) !== "G" &&
      cedcontri.substring(0, 1) !== "E" &&
      cedcontri.substring(0, 1) !== "P"
        ? ""
        : cedcontri.substring(0, 1);
    txtRif.current.value =
      cedcontri.substring(0, 1) !== "J" &&
      cedcontri.substring(0, 1) !== "V" &&
      cedcontri.substring(0, 1) !== "G" &&
      cedcontri.substring(0, 1) !== "E" &&
      cedcontri.substring(0, 1) !== "P"
        ? cedcontri
        : cedcontri.substring(1);
    txtDireccion.current.value = dircontri;
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        radioGeneral.current.checked = true;
        radioComercio.current.checked = false;
        radioInmueble.current.checked = false;
        seleccionarTipoIngreso();
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex align-items-center justify-content-between azulGradiant">
        <h3 className="m-0 fw-bold">Impresión de Facturas - Tasas</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={cancelar}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap">
        <div className="col-3 m-0 mb-2 ml-auto p-0">
        <Input
            label="Fecha:"
            disabled
            id="inputTotalDeclarado"
            defaultValue={moment.utc(fechaSistema).format("DD/MM/YYYY")}
        />
        </div>
        <div className="col-3 m-0 mb-2 p-0 text-end">
        Valor Euro €:
        {formatMoneda(
            props.factorCambio.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
        )}
        </div>
        <div className="col-12 m-0 mb-2 p-0">
        <Select
            label="Departament:"
            ref={cmbDepartamento}
            onChange={handleChangeDeparatamento}
        >
            <option key={0} value={0}>
            {espiritu === 9 ? "SERAMAT" : "HACIENDA"}
            </option>
            <option key={1} value={1}>
            LICORES
            </option>
            <option key={2} value={2}>
            CATASTRO
            </option>
            <option key={3} value={3}>
            REGISTRO CIVIL
            </option>
            <option key={4} value={4}>
            TRANSPORTE
            </option>
            <option key={5} value={5}>
            {espiritu === 9 ? "INGENIERIA" : "INFRAESTRUCTURA"}
            </option>
            <option key={6} value={6}>
            SINDICATURA
            </option>
            <option key={7} value={7}>
            PROTECCION CIVIL
            </option>
        </Select>
        </div>
        <div className="col-12 m-0 mb-2 p-0">
        <Select
            label="Tipo de Ingreso:"
            ref={cmbTipoIngreso}
            onChange={handleChangeTipoIngreso}
        >
            {tipoIngreso &&
            tipoIngreso.map((tipo) => (
                <option key={tipo.idtasasweb} value={tipo.idtipoingreso}>
                {tipo.descripcion.trim()}
                </option>
            ))}
            ;
        </Select>
        </div>
        <div className="col-8 m-0 p-0 d-flex gap-2">
        <div class="col-auto m-0 p-0">
            <Radio
            label="General"
            class="form-check-input my-auto"
            type="radio"
            name="radioTipo"
            id="radioGeneral"
            ref={radioGeneral}
            onChange={onChange}
            />
        </div>
        <div class="col-auto m-0 p-0">
            <Radio
            label="Act.Economica"
            name="radioTipo"
            id="radioComercio"
            ref={radioComercio}
            onChange={onChange}
            />
        </div>
        <div class="col-auto m-0 p-0">
            <Radio
            label="Inmuebles urb."
            name="radioTipo"
            id="radioInmueble"
            ref={radioInmueble}
            onChange={onChange}
            />
        </div>
        </div>
        <fieldset className="col-12 m-0 mb-2 p-2 d-flex flex-wrap border-azul rounded">
        <legend className="float-none m-0 w-auto ">
            Datos del Contribuyente
        </legend>
        <div className="col-5 m-0 mb-2 p-0 d-flex">
            <Select
            label="Cédula o Rif:"
            disabled={habilitaBotBuscar}
            ref={cmbRif}
            id="inputLetraRif"
            >
            <option value="J">J</option>
            <option value="V">V</option>
            <option value="G">G</option>
            <option value="E">E</option>
            <option value="P">P</option>
            </Select>
            <SearchInput
            disabled={habilitaBotBuscar}
            ref={txtRif}
            autoComplete="off"
            id="inputRif"
            name="rif"
            onChange={onChange}
            onClickButton={handleCatalogo}
            disabledButton={!habilitaBotBuscar}
            />
        </div>
        <div className="col-12 m-0 mb-2 p-0">
            <Input
            label="Nombres:"
            disabled={habilitaBotBuscar}
            ref={txtNombre}
            autoComplete="off"
            id="inputNombre"
            name="nombre"
            onChange={onChange}
            />
        </div>
        <div className="col-12 m-0 p-0">
            <Textarea
            label="Dirección:"
            disabled={habilitaBotBuscar}
            ref={txtDireccion}
            style={{ height: 70 }}
            autoComplete="off"
            id="inputDireccion"
            name="direccion"
            onChange={onChange}
            />
        </div>
        </fieldset>
        <div className="col-12 m-0 mb-2 p-0">
        <Textarea
            label="Concepto:"
            disabled
            ref={txtConcepto}
            style={{ height: 70 }}
            id="inputTotalDeclarado"
        />
        </div>
        <div className="col-3 m-0 p-0">
        <Select
            label="Cantidad:"
            ref={cmbCantidad}
            onChange={handleChangeCantidad}
        >
            <option key={1} value={1}>
            1
            </option>
            <option key={2} value={2}>
            2
            </option>
            <option key={3} value={3}>
            3
            </option>
            <option key={4} value={4}>
            4
            </option>
            <option key={5} value={5}>
            5
            </option>
            <option key={6} value={6}>
            6
            </option>
            <option key={7} value={7}>
            7
            </option>
            <option key={8} value={8}>
            8
            </option>
            <option key={9} value={9}>
            9
            </option>
            <option key={10} value={10}>
            10
            </option>
        </Select>
        </div>
        <div className="col-4 m-0 p-0" style={{ visibility: visibleUT }}>
        <Input
            label="Valor Unidad:"
            autoComplete="off"
            ref={txtUnidad}
            key="unidad"
            name="unidad"
            onFocus={seleccionarCampo}
            onKeyUp={handleInputChange1}
            onBlur={handleInputChange1}
            defaultValue="0,00"
        />
        </div>
        <div className="col-5 m-0 p-0">
        <Input
            label="Monto Total a Facturar:"
            inputClassName="text-end"
            disabled
            ref={txtTotal}
            id="inputTotalDeclarado"
        />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          onClick={onChangeValidar}
        >
            Aceptar
        </SuccessButton>
        <DangerButton
          onClick={cancelar}
        >
            Cancelar
        </DangerButton>
      </Modal.Footer>

      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() => {
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
          txtNombre.current.value = "";
          txtRif.current.value = "";
          txtDireccion.current.value = "";
          props.onHideAcepta();
          blanquear();
        }}
        onHideSi={handleCloseSi}
      />

      <CatalogoComercio
        titulo={titulo}
        mensaje={msg}
        show={mostrarComercio}
        onHideCancelaCatCom={() => {
          setMostrarComercio(false);
        }}
        onHideAceptaCatCom={infoCatalogoC}
        caja={true}
      />

      <CatalogoInmueble
        show={mostrarInmueble}
        onHideCancelaCatInm={() => {
          setMostrarInmueble(false);
        }}
        onHideAceptaCatInm={infoCatalogoI}
      />

      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
